module.exports = __webpack_public_path__ + "static/media/welcomeTdxLogo.793d49ad.png";